import styled from "styled-components";
import { color } from "../../res/colors";

export const Box = styled.section`
  padding: 24px;
  background-color: ${color.WHITE};
  border-radius: 8px;
  margin: auto;
  width: ${(p) => (p.notfull ? "700px" : "100%")};
  max-width: 600px;

  @media (max-width: 750px) {
    width: 100%;
    padding: 24px 16px;
  }
`;
